import { AddLocationPin } from "../../icons";
import { useNitroStore } from "../../store/Store";
import "./index.css";

const AddLocationButton = () => {
  const [setShowAddLocationPanel] = useNitroStore((state) => [
    state.setShowAddLocationPanel,
  ]);

  return (
    <button
      type="button"
      className="addLocationButton"
      onClick={() => {
        setShowAddLocationPanel(true);
      }}
      title="Add location"
      aria-label="Add location"
    >
      <div className="addLocationButtonIcon" aria-hidden="true">
        <AddLocationPin />
      </div>
      <div className="addLocationButtonLabel">
        <span>Add</span>
        <span>Location</span>
      </div>
    </button>
  );
};

export default AddLocationButton;
